'use strict';
var conversionUtils = require("../../mobileCore/main/conversionUtils");
var sortingUtils = require("./sortingUtils");
var mobileLayoutUtils = {
    translateComponents: conversionUtils.translateComps,
    getSnugLayout: conversionUtils.getSnugLayout,
    splitToFragments: sortingUtils.splitToFragments,
    sortSiblings: sortingUtils.sortSiblings,
    getComponentsOrder: sortingUtils.getComponentsOrder
};
module.exports = mobileLayoutUtils;



//////////////////
// WEBPACK FOOTER
// ./src/mobileLayoutUtils/main/mobileLayoutUtilsPublicAPI.ts
// module id = 32
// module chunks = 1